<template>
  <div @click="expandCart(false)" class="cart-container" :class="[expanded == true ? 'expanded' : '']">
      <div @touchstart="dragStart" @touchend="dragEnd" v-on:click.stop class="unexpanded-cart" v-if="expanded == false">
            <div class="product-preview-container">
                <div class="products-container">
                    <div v-for="addonProduct in selectedAddonProducts" :key="addonProduct.variants[0].id" class="addon-container">
                        <div class="alert-overlay" v-if="isExtendedBoxes && extendedProducts.includes(addonProduct.title) && step == 2">
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>
                        </div>
                        <img class="main-image" :src="getProductImage(addonProduct)">
                        <p class="floating-qty">{{addonProduct.quantity}}</p>
                    </div>
                    <div v-if="selectedBoxProduct" class="addon-container">
                        <img class="main-image" :src="getProductImage(selectedBoxProduct)">
                    </div>
                    <div v-if="selectedCardProduct" class="addon-container">
                        <img class="main-image" :src="getProductImage(selectedCardProduct)">
                    </div>
                </div>
            </div>
            <div class="buttons-container">
                <button @click="expandCart(true)" class="happybox-button white border">Expand</button>
                <button v-if="step != 3" @click="changePage(true)" class="happybox-button green border">Next ></button>
                <button v-else @click="next()" class="happybox-button green border" :class="isloading ? 'isLoading' : ''">{{ isloading ? "loading..." : "Next >"}}</button>
            </div>
        </div>
      <div v-on:click.stop class="expanded-cart">
            <div @touchstart="dragStart" @touchend="dragEnd" class="expanded-cart-header">
                <p @click="expandCart(false)" class="close-alert color-link">&lt; Keep Shopping</p>
                <div class="box-name-container flex flex-align-center">
                    <img width="20px" height="20px" class="h-auto m-r-05rem" src="https://cdn.shopify.com/s/files/1/1363/8433/files/gift_blue.svg?v=1749489581"/>
                    <input placeholder="Give Your Box a Name" v-on:keyup.enter="editName(false)" @blur="checkName()" class="body-base placeholder-italic" type="text" maxlength="34" v-model="boxName">
                </div>
            </div>
            <div class="product-summary-container no-scrollbar">
                <div class="product-summary">
                    <p class="summary-title">Box Contents</p>
                    <p class="summary-text" v-if="productQtyCopy">{{ productQtyCopy }}</p>
                    <ul class="products-container">
                        <li v-for="addonProduct in selectedAddonProducts" :key="addonProduct.variants[0].id">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img @click="openModalProduct(addonProduct)" class="main-image" :src="getProductImage(addonProduct)"/>
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p class="title">{{addonProduct.title}}</p>
                                    </div>
                                    <div class="product-data-container">
                                        <p class="price">{{addonProduct | moneyFormat}}</p>
                                        <div class="product-qty-container">
                                        <select v-model="addonProduct.quantity" @change="changeOnDemand(addonProduct)">
                                            <option v-for="qty in addonMaxQty(addonProduct)" :key="qty" :value="qty">{{qty}}</option>
                                        </select>
                                        <img @click="removeProduct(addonProduct)" class="delete-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833">
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-if="selectedBoxProduct">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img class="main-image" :src="getProductImage(selectedBoxProduct)"/>
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p class="title">{{selectedBoxProduct.title}}</p>
                                    </div>
                                    <div class="product-data-container">
                                        <p class="price">{{selectedBoxProduct | moneyFormat}}</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-if="selectedCardProduct">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img class="main-image" :src="getProductImage(selectedCardProduct)"/>
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p class="title">{{selectedCardProduct.title}}</p>
                                    </div>
                                    <div class="product-data-container">
                                        <p class="price">{{selectedCardProduct | moneyFormat}}</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <button @click="removeAll()" class="remove-all color-link">Remove All</button>
                </div>
                <div class="box-container">
                    <div class="box-qty-container">
                        <p>Box Quantity</p>
                        <div class="box-qty-input-container">
                            <button :disabled="selectedBoxQty == 1" @click="incrementBoxQty(false)">-</button> 
                            <input @blur="changeBoxQty(null)" v-model="selectedBoxQty" type="number" min="1"> 
                            <button @click="incrementBoxQty(true)">+</button>
                        </div>
                    </div>
                    <p class="multiship-notice">Adjust the quantity if you'd like duplicates of this box, even if you're shipping to different addresses!</p>
                    <p class="custom-notice" v-if="customAlert">{{customAlert}}</p>
                </div>
                <div class="summary-container">
                    <div class="item-summary">
                        <p class="item-title">Box Summary</p>
                        <div class="box-total">
                            <div class="total-container">
                                <p v-if="boxQty > 1" class="title"><strong>({{boxQty}})</strong> {{boxName}}</p>
                                <p v-else class="title">{{boxName}}</p>
                                <p class="price">{{ totalPrice * boxQty | moneySaleFormat}}</p>
                            </div>
                            <p class="individual-price">{{totalPrice | moneySaleFormat}} per box</p>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Gift Box Design <span v-if="step == 1">(selected at next step)</span></p>
                                <p v-if="selectedBoxProduct" class="price">{{ boxPrice * boxQty | moneySaleFormat }}</p>
                                <p v-else class="price">$--</p>
                            </div>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Card <span v-if="step == 2">(selected at future step)</span></p>
                                <p v-if="selectedCardProduct" class="price">{{ cardPrice * boxQty | moneySaleFormat }}</p>
                                <p v-else class="price">$--</p>
                            </div>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Handpacking Fee</p>
                                <p class="price">{{ feePrice * boxQty | moneySaleFormat }}</p>
                            </div>
                            <p class="purple-legend" v-if="hasOnDemandProducts"> Some items in your cart may  require 1-2 week lead time.  But trust us, they're worth the wait!</p>
                            <p v-else-if="hasCustomProducts" class="individual-price">Custom items require a lead time of at least 1-2 weeks. Our team will reach out via email to coordinate shipping details.</p>
                        </div>
                        <div class="item-total">
                            <p class="title">Item Total</p>
                            <p class="price">{{ (totalPrice * boxQty) | moneySaleFormat}}</p>
                        </div>
                    </div>
                    <div class="taxes-container">
                        <p class="title">Taxes <strong>(calculated in checkout)</strong></p>
                        <p class="price">--</p>
                    </div>
                    <div class="separator"></div>
                    <div class="subtotal-container">
                        <p class="title">Estimated Subtotal</p>
                        <p class="price">{{ (totalPrice * boxQty) | moneySaleFormat}}</p>
                    </div>
                    <div class="multiship-block">
                        <p><strong>Shipping to multiple addresses?</strong></p>
                        <p><a href="https://cdn.shopify.com/s/files/1/1363/8433/files/Happy_Box_Shipping_Template.xlsx?v=1679594143" download target="_blank">Click</a> to download our bulk shipping <br/> template to upload at checkout!</p>
                    </div>
                </div>
                <div v-if="recommendedAddons.length > 0" class="recommendation-container">
                    <p class="title">Perfect fit for your box</p>
                    <div class="recommended-addon-container no-scrollbar">
                        <div class="recommended-addon" v-for="addon in recommendedAddons" :key="addon.id">
                            <img @click="openModalProduct(addon)" :src="addon.image.src" class="main-image">
                            <button @click="updateReccomendedAddonProductQuantity(addon)" class="happybox-button white border">{{ addCopy }}</button>
                            <p class="addon-title">{{addon.title}}</p>
                            <p class="price">{{addon.variants[0].price | moneySaleFormat}}</p>
                        </div>
                    </div>
                </div>
                <VueSlickCarousel :infinite="true" :dots="true" :arrows="true" :slidesToShow="1" :slidesToScroll="1">
                    <template #prevArrow="arrowOption">
                        <div>
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648">
                        </div>
                    </template>
                    <div v-if="hasOnDemandProducts" class="notice-container">
                        <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/box.svg?v=1658459692"/>
                        <div>
                            <p class="title">Items may take up to ~2 weeks to ship</p>
                            <p class="subtitle">All boxes are made to order, <br/> just for you!</p>
                        </div>
                    </div>
                    <div v-else class="notice-container">
                        <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/box.svg?v=1658459692"/>
                        <div>
                            <p class="title">We hand-pack your items!</p>
                            <p class="subtitle">Our team will ensure your box <br/> feels full and is packed perfectly!</p>
                        </div>
                    </div>
                    <div class="notice-container">
                        <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/boxwings.svg?v=1658459692"/>
                        <div>
                            <p class="title">Multiple addresses? No problem!</p>
                            <p class="subtitle">Ship to one or many locations all <br/> in one, easy checkout</p>
                            <a target="_blank" href="https://www.loom.com/share/d6c4740fe5534425a14581d913b91910?sid=672876ae-7e19-49bd-b06a-b75f17df94ac">Watch the Demo</a>
                        </div>
                    </div>
                    <template #nextArrow="arrowOption">
                        <div>
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648">
                        </div>
                    </template>
                </VueSlickCarousel>
          </div>
          <div class="complete-box">
              <button v-if="step != 3" @click="changePage(true)" class="happybox-button green border">Next ></button>
              <button v-else @click="bundle()" class="happybox-button green border" :class="isloading ? 'isLoading' : ''">{{ isloading ? "loading..." : "Continue to Cart"}}</button>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel'
import smoothReflow from 'vue-smooth-reflow'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    mixins: [smoothReflow],
    props: {
    },
    components: {
        VueSlickCarousel,
    },
    props: {
        step: Number,
    },
    data() {
      return {
        expanded: false,
        selectedBoxQty: 1,
        startingY: 0,
        isEditingName: false,
        boxAlert: "",
        showBoxAlert: false,
        isloading: false,
      }
    },
    watch: {
        boxQty: {
            handler(val){
                this.selectedBoxQty = val;
            },
            deep: true
        },
    },
    computed:{
        ...mapGetters([
            'maxCapacity',
            'currentCapacity',
            'productLimit',
            'boxProducts',
            'defaulBoxName',
            'cartNames',
            'feeProduct',
            'cardProducts',
            'customData',
            'addonProducts',
            'addCopy',
            'selectedAddonProducts',
            'selectedCardProduct',
            'selectedBoxProduct',
            'selectedOccasion',
            'selectedCategories',
            'selectedFilters'
        ]),
        totalPrice(){
            let total = 0;
            if(this.selectedAddonProducts.length > 0){
               total += this.selectedAddonProducts.map(x => x.variants.length ? parseFloat(x.variants[0].price * x.quantity) : 0)
                .reduce((prev, next) => prev + next, 0);
            }
            if(this.selectedBoxProduct){
                total += parseFloat(this.selectedBoxProduct.variants[0].price);
            }
            if(this.selectedCardProduct){
                total += parseFloat(this.selectedCardProduct.variants[0].price);
            }
            if(this.feeProduct){
                total += parseFloat(this.feeProduct.variants[0].price / 100);
            }

            return total.toFixed(2)
        },
        shippingPrice(){
            return 12
        },
        boxQty: {
            get(){ return this.$store.state.boxQty},
            set(value){this.$store.commit('setBoxQty', value )}
        },
        boxName: {
            get(){ return this.$store.state.boxName},
            set(value){this.$store.commit('setBoxName', value )}
        },
        leftOverCapacity(){
            return this.maxCapacity - this.currentCapacity;
        },
        recommendedAddons(){
            if(this.addonProducts.length > 0){
                let filterAddons =  JSON.parse(JSON.stringify(this.addonProducts));
                //filter via occasion
                if(this.selectedOccasion.length > 0){
                    filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasion.some(z => y.includes(z))));
                }

                //Filter categories
                if(!this.selectedCategories.includes("View All"))
                    filterAddons = filterAddons.filter(x => x.tags.some(y =>  this.selectedCategories.some(z => y.includes(z))));

                //Filter for each category
                for(let filter of this.selectedFilters){
                    filterAddons = filterAddons.filter(x => filter.filters.some(y => x.tags.includes(y)));
                }

                //Exclude products
                let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
                if(excludeFilters.length > 0){
                    let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                    excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                    filterAddons = filterAddons.filter(x => !excludedTags.includes(x.id));
                }
            
                var addonCartIds = this.selectedAddonProducts.map(x => x.id);
                if(filterAddons.length > 0){
                    let products = filterAddons.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude"))).slice(0,3);
                    if(products.length > 0)
                        return products.sort((a,b) => a.capacity - b.capacity);
                    
                    return this.addonProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude"))).sort((a,b) => a.capacity - b.capacity).slice(0,3);
                }
            }

            return [];
        },
        totalQtyProducts(){
            return this.selectedAddonProducts.map(x => x.quantity).reduce((prev, next) => prev + next, 0);
        },
        canAddMore(){
            var canAddArray = this.selectedAddonProducts.every((x) =>{
                return ((this.boxQty + 1) * x.quantity) <= this.productCurrentVariantInventory(x)
            })

            return canAddArray
        },
        boxPrice(){
            if(this.selectedBoxProduct){
                return parseFloat(this.selectedBoxProduct.variants[0].price);
            }

            return 0
        },
        cardPrice(){
            if(this.selectedCardProduct){
                return parseFloat(this.selectedCardProduct.variants[0].price);
            }

            return 0;
        },
        feePrice(){
            if(this.feeProduct){
                return parseFloat(this.feeProduct.variants[0].price / 100);
            }

            return 0;
        },
        hasCustomProducts(){
            return this.selectedAddonProducts.some(x => x.tags.some(y => y.includes("Customizable")))
        },
        hasOnDemandProducts(){
            return this.selectedAddonProducts.some(x => x.variants[0].sku.toLowerCase().includes("ondemand"))
        },
        customAlert(){
            let productList = this.selectedAddonProducts.filter(x => x.tags.some(x => x.includes("QTYMIN") && !x.includes("DEMAND")));
            if(productList.length > 0){
                var productTitles = productList.map(x => x.title);
                let minQtys = productList.map((x) =>{
                    let minTag = x.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];
                        return minTag;
                    }

                    return 1
                })
                let maxQty = Math.max([...minQtys])
                return `The following product(s): "${productTitles.join(", ")}" requires a minimum of ${maxQty} units to be included in your boxes. If you lower your box quantity below this amount, this item will be removed`
            }

            return null
        },
        productQtyCopy(){
            if(this.totalQtyProducts == 1)
                return "Great start! We recommend adding a few more items to fill your gift box."
            if(this.totalQtyProducts < 5)
                return "Nice picks! Pro-tip: boxes look best with 5-7 items"
            if(this.totalQtyProducts < 8)
                return "Wow, this gift looks fantastic."
            if(this.totalQtyProducts >= 8)
                return "You’re a gifting pro! They’re going to love it."

            return null;
        },
        currentMaxCapacity(){
            if(!this.selectedBoxProduct){
                return this.maxCapacity;
            }
            else{
                return parseInt(this.selectedBoxProduct.variants[0].option1)
            }
        },
        lesserMaxCapacity(){
            //get biggest box that is not extended
            let capacities = this.boxProducts.filter(x => !x.title.toLowerCase().includes("extended")).map(x => x.variants).flat().filter(x => x.available).map(x => parseInt(x.option1)).sort((a,b) => b - a);
            return capacities.find(x => x < this.currentMaxCapacity)
        },
        isExtendedBoxes(){
            return this.currentCapacity > this.lesserMaxCapacity;
        },
        extendedProducts(){
            if(this.isExtendedBoxes){
                //find a product that when removed jumps to not extended box
                let cartProducts = JSON.parse(JSON.stringify(this.selectedAddonProducts))
                let products = cartProducts.sort((a,b) => b.capacity - a.capacity);//.find(x => (this.currentCapacity - x.capacity) <= this.lesserMaxCapacity);
                let titles = [];
                let capacity = Number(this.currentCapacity);
                for(let i = 0; capacity > this.lesserMaxCapacity; i++){
                    titles.push(products[i].title);
                    capacity = capacity - (products[i].capacity * products[i].quantity);
                }

                return titles.join(", ");
            }

            return null
        },
    },
    methods:{
        removeProduct(product){
            this.$store.commit('removeSelectedAddonProductNew', product);
        },
        editName(edit){
            this.isEditingName = edit;
        },
        expandCart(expand){
            this.expanded = expand;
        },
        incrementBoxQty(increment){
            if(increment){
                this.changeBoxQty(this.boxQty + 1)
            }
            else {
                if(this.boxQty > 1){
                    this.changeBoxQty(this.boxQty - 1)
                }
            }
        },
        bundle(){
            if(this.selectedAddonProducts.length > 0 && this.selectedBoxProduct && this.selectedCardProduct){
                this.isloading = true;
                this.$emit("bundle");
            }
            else{
                this.expandCart(false);
                this.changePage(true);
            }
        },
        next(){
            if(this.selectedAddonProducts.length > 0 && this.selectedBoxProduct && this.selectedCardProduct){
                this.expandCart(true)
            }
            else{
                this.changePage(true);
            }
        },
        addonMaxQty(addon){
            const min = 1,
            max = this.getProductMaxQty(addon),
            interval = 1;
            const length = (max - min) / interval + 1;
            let arr = Array.from({ length }, (_, i) => min + i * interval);

            if(this.demandQtyMin(addon) > 0){
                arr = this.checkOnDemandArray(arr,addon);
            }

            return arr;
        },
        getProductMaxQty(addon){
            //Get max value posible in products, no more than the product limit per box
            var maxValues = [this.productLimit]
            //Get limit based on inventory * total boxes
            let inventoryQty = this.productCurrentVariantInventory(addon)
            maxValues.push(Math.floor( inventoryQty / this.boxQty));
            //Get limit based on currentCapacity
            let maxPerCapacity = Math.max(...[Math.floor((this.maxCapacity - this.currentCapacity) / addon.capacity + this.getProductCurrentQty(addon)),this.getProductCurrentQty(addon)])
            maxValues.push(maxPerCapacity);

            return Math.min(...maxValues)
        },
        getProductCurrentQty(currentProduct){
          var product = this.selectedAddonProducts.find(x => x.id == currentProduct.id);
          if(product)
            return product.quantity
          return 0
        },
        updateReccomendedAddonProductQuantity(product){
            var productQty = this.getProductCurrentQty(product) + 1;
            this.$store.commit('updateSelectedAddonProductsNew',{product: product, quantity: productQty});
        },
        changePage(increment){
            this.$emit("changepage", increment);
            this.expandCart(false);
        },
        changeBoxQty(qty){
            //Validate if cart products can support box qty if not show alert
            this.selectedBoxQty = qty ? qty : parseInt(this.selectedBoxQty);
            var canUpdate = this.selectedAddonProducts.filter((x) =>{
                let demandQty = this.demandQtyMin(x);
                if(demandQty >= this.selectedBoxQty)
                    return false
                if((this.selectedBoxQty * (x.quantity)) > this.productCurrentVariantInventory(x) )
                    return true

                return false
            })

            let customizableUpdate = this.selectedAddonProducts.filter((x) =>{
                if(x.tags.some(x => x.includes("QTYMIN") && !x.includes("DEMAND"))){
                    let minTag = x.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];
                        if(this.selectedBoxQty < parseInt(minTag)){
                            return true;
                        }
                    }
                }

                return false
            })

            let ondemandUpdate = this.selectedAddonProducts.filter((x) =>{
                let demandQty = this.demandQtyMin(x);
                if(demandQty > 0){
                    let product = this.addonProducts.find(y => y.id == x.id);
                    let notDemand = product.variants.find(y => !y.sku.toLowerCase().includes("ondemand"));
                    if(this.selectedBoxQty * x.quantity < demandQty && notDemand.inventory_quantity < this.selectedBoxQty * x.quantity){
                        return true;
                    }
                }

                return false
            })

            if(customizableUpdate.length > 0){
                this.openBoxQtyCustomConfirmation(customizableUpdate);
            }
            else if(ondemandUpdate.length > 0){
                this.openBoxQtyOnDemandConfirmation(ondemandUpdate);
            }
            else if(canUpdate.length > 0){
                this.openBoxQtyConfirmation(canUpdate);
            }
            else {
                this.boxQty = this.selectedBoxQty;
                this.checkOnDemand();
            }
        },
        openBoxQtyConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            const alertText = "The following product(s) don't have enough inventory to match the quantity of boxes you've requested: " + productTitles.join(", ") + ". Here are your options:";
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll take what you have (& reduce my number of boxes)",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-2",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.boxQty = this.selectedBoxQty
                    this.checkOnDemand();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        openBoxQtyOnDemandConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            let minQtys = productList.map((x) =>{
                let minTag = x.tags.find(x => x.includes("DEMAND_QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];
                    return minTag;
                }

                return 1
            })
            let maxQty = Math.max([...minQtys])
            const alertText = `Please note: "${productTitles.join(", ")}" requires a minimum of ${maxQty} units to be included in your boxes. If you lower your box quantity below this amount, this item will be removed`
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll keep my boxes",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-2",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.changeBoxQty();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        openBoxQtyCustomConfirmation(productList){
            const alertText = this.customAlert;
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll keep my boxes",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.changeBoxQty();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        dragStart(event){
            this.startingY = event.touches[0].screenY;
        },
        dragEnd(event){
            if((event.changedTouches[0].screenY - this.startingY) < -100)
                this.expandCart(true);
            else if ((event.changedTouches[0].screenY - this.startingY) > 100)
                this.expandCart(false);
        },
        checkName(){
            if(this.boxName == ""){
                this.boxAlert = "Box name cannot be empty";
                this.showBoxAlert = true;
                this.boxName = this.defaulBoxName;
            }
            else if (this.cartNames.includes(this.boxName)){
                this.boxAlert = "Another box has the same name"
                this.showBoxAlert = true;
                this.boxName = this.defaulBoxName;
            }
            else {
                this.boxAlert = ""
                this.showBoxAlert = false;
            }
            let that = this;
            setTimeout(() => {that.showBoxAlert = false;}, 2000);
            this.isEditingName = false;
        },
        removeAll(){
            this.$store.commit('updateAllSelectedAddonProducts', []);
            this.expandCart(false);
        },
        openModalProduct(product){
            this.$emit("openmodal",product);
            this.expandCart(false);
        },
        getProductImage(product){            
            return (product.images.length > 0) ? product.images[product.images.length - 1].src : ''
            
        },
        isOnDemand(addon){
            let product = this.addonProducts.find(x => x.id == addon.id);
            return product.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
        },
        productCurrentVariantInventory(product){
            if(this.isOnDemand(product))
                return 9999;
            return product.variants[0].inventory_quantity;
        },
        changeOnDemand(addonProduct){
            if(this.isOnDemand(addonProduct)){
                let product = this.addonProducts.find(x => x.id == addonProduct.id);
                var variantProduct = JSON.parse(JSON.stringify(product));
                let notDemand = variantProduct.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                let onDemand = variantProduct.variants.find(x => x.sku.toLowerCase().includes("ondemand"));
                if(notDemand.inventory_quantity >= addonProduct.quantity * this.boxQty  || this.demandQtyMin(addonProduct) > this.boxQty * addonProduct.quantity){
                    variantProduct.variants = [notDemand];
                }
                else 
                    variantProduct.variants = [onDemand];

                if(addonProduct.variants[0].id != variantProduct.variants[0].id){
                    this.$store.commit('updateSelectedAddonProductsNew',{product: addonProduct, quantity: 0});
                    this.$store.commit('updateSelectedAddonProductsNew',{product: variantProduct, quantity: addonProduct.quantity});
                }
            }
        },
        checkOnDemand(){
            let cartIds = this.selectedAddonProducts.map(x => x.id);
            let onDemandProducts = this.addonProducts.filter(x => cartIds.includes(x.id) && x.variants.some(y => y.sku.toLowerCase().includes("ondemand")));
            if(onDemandProducts.length > 0){
                let ondemandIds = onDemandProducts.map(x => x.id);
                let ondemandCartProducts = this.selectedAddonProducts.filter(x => ondemandIds.includes(x.id));
                for(let addon of ondemandCartProducts){
                    this.changeOnDemand(addon)
                }
            }
        },
        demandQtyMin(addon){
            let demandQtymin = addon.tags.find(x => x.includes("DEMAND_QTYMIN"));
            if(demandQtymin){
                if(demandQtymin){
                    demandQtymin = demandQtymin.split("_");
                    demandQtymin = demandQtymin[demandQtymin.length - 1];

                    return  parseInt(demandQtymin);
                }
            }

            return 0;
        },
        checkOnDemandArray(arr,addon){
            let demandMinQty = this.demandQtyMin(addon);
            let product = this.addonProducts.find(x => x.id == addon.id);
            const notDemand = product.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
            const notDemandInventory = notDemand.inventory_quantity;
            for(let int of arr){
                if((int * this.boxQty) < demandMinQty && (int * this.boxQty) > notDemandInventory)
                arr.splice(int-1,1);
            }

            return arr;
        },
    },
    mounted() {
        this.$smoothReflow({
            property: ['height'],
            transition: 'height 1s'
        });
        this.selectedBoxQty = this.boxQty;
    }
}
</script>

<style lang="scss" scoped>

.cart-container{
    position: fixed;
    bottom: 0%;
    width: 100%;
    height: 0%;
    background-color: rgba(0, 0, 0, 0.2);
    box-shadow: inset 0px 1px 0px #E6E8EC;
    left: 0%;
    right: 0%;
    display: none;
    padding-top: unset;
    align-items: flex-end;
    z-index: 4;
}

.cart-container.expanded{
    height: 100%;
}
//Unexpanded cart css
.unexpanded-cart{
    width: 100%;
    box-shadow: 0px -18px 8px rgba(31, 41, 55, 0.1);
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    position: fixed;
    bottom: 0;
    height: auto;
    background-color: white;
}

.unexpanded-cart .happybox-button{
    flex: 1;
    padding: 1%;
}

.unexpanded-cart .buttons-container{
    width: 100%;
    display: flex;
    align-items: center;
    gap: 5%;
    padding: 2%;
}

.product-preview-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.unexpanded-cart .products-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: scroll;
    margin-bottom: 1rem;
}

.unexpanded-cart .addon-container{
    width: 15%;
    position: relative;
    padding: 3% 2% 0%;
    flex-shrink: 0;
}

.unexpanded-cart .addon-container .main-image{
    border: unset;
    background-color: #F3F4F6;
    width: 100%;
}

.unexpanded-cart .addon-container .floating-qty{
    position: absolute;
    top: 0.5rem;
    right: 0rem;
    background-color: #fff;
    border: 1px solid #9CA3AF;
    border-radius: 100px;
    font-size: 1rem;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.preview-box{
    color: #0F0C38;
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 1;
    text-align: right;
    padding: 2% 5%;
    position: absolute;
    right: 0;
    top: -2.35rem;
    background-color: white;
    border-radius: 20px 20px 0 0;
    box-shadow: 0px -8px 8px rgba(31, 41, 55, 0.1);
}

.addon-container select{
    width: 50%;
    background-color: #FFFFFF;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    padding: 0% 0% 0% 10%;
    height: unset;
    margin-right: 10%;
}
.delete-button{
    width: 30%;
    background: #FFFFFF;
    border-radius: 4px;
}

//Expanded Cart Css
.expanded-cart{
    width: 100%;
    height: 85%;
    background-color: white;
    display: flex;
    flex-direction: column;
    border-radius: 16px 16px 0px 0px;
    position: absolute;
    bottom: 0;
    overflow-y: scroll;
}

.expanded-cart .close-alert{
    letter-spacing: 0;
    font-size: 3.5vw;
    left: 2%;
    font-family: karla;
    font-weight: bold;
    width: 30%;
    margin-right: 10%;
}

.product-summary-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0% 2%;
    overflow-y: scroll;
}

.product-summary{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border: 1px solid #E8E1F2;
    box-sizing: border-box;
    border-radius: 4px;
    margin-top: 5%;
    padding: 2%;
}

.summary-title{
    color:#0F0C38;
    font-size: 1.2rem;
    line-height: 1.5;
    font-weight: bold;
}

.summary-text{
    color:#0F0C38;
    font-size: 1rem;
    line-break: 1.43;
}

.expanded-cart .products-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    list-style: none;
    justify-content: space-between;
    margin: unset;
    padding: 5% 2%;
}


.expanded-cart .products-container li{
    width: 100%;
}

.expanded-cart .addon-container{
    width: 100%;
    display: flex;
    margin-bottom: 0.5rem;
}

.expanded-cart .addon-container .image-container{
    width: 20%;
}

.expanded-cart .addon-container .main-image{
    width: 100%;
    background-color: #f6f6f6;
}

.expanded-cart .product-information{
    width: 80%;
    display: flex;
    flex-direction: column;
    padding-left: 5%;
    justify-content: space-between;
}

.expanded-cart .product-information .product-data-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.expanded-cart .product-information .title{
    line-height: 1.43;
    font-size: 1rem;
    font-weight: bold;
}

.expanded-cart .product-information .price{
    line-height: 1.43;
    font-size: 1rem;
}

.product-qty-container{
    width: 50%;
    display: flex;
}

.product-qty-container select{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    padding: 1% 2% !important;
    text-align: center;
    font-size: 1.1rem;
    width: 70% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
}

.product-qty-container .delete-button{
    width: 20%;
}

.box-container{
    background-color: #F9FAFB;
    margin-top: 5%;
    padding: 0% 2% 2% 2%;
}

.box-qty-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3% 0%;
}
.box-qty-container p{
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 1.5;
    color: #0F0C38;
}


.box-qty-input-container{
    width: 50%;
    display: flex;
    justify-content: flex-end;
}

.box-qty-input-container input{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    text-align: center;
    font-size: 1.2rem;
    width: 30% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
    font-weight: 700;
    color: #0F0C38;
}

.box-qty-input-container input::-webkit-inner-spin-button,
.box-qty-input-container input::-webkit-outer-spin-button{
   -webkit-appearance: none;
    margin: 0;
}

.box-qty-input-container button{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    padding: 0% 1.2rem;
    margin: 0% 5%;
    color: #0F0C38;
}

.box-qty-input-container button:disabled{
    background-color: lightgray;
    opacity: 0.6;
}

.multiship-notice{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.43;
    color: #0F0C38;
}

.custom-notice{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
    color: #581C87;
    margin-top: 5%;
}

.recommendation-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 5% 0%;
}

.recommendation-container .title{
    width: 100%;
    width: 100%;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.6;
    color: #0F0C38;
    padding-bottom: 2%;
}

.recommended-addon-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
}

.recommended-addon{
    width: 40%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    margin-right: 5%;
}

.recommended-addon .main-image{
    width: 100%;
    margin-bottom: 5%;
}

.recommended-addon .addon-title{
    font-weight: 700;
    color: #0F0C38;
    line-height: 1.2;
    font-size: 1rem;
    margin-top: 5%;
}

.expanded-cart .happybox-button.white{
    padding: 3% 0%;
}

.complete-box{
    position: sticky;
    bottom: 0%;
    box-shadow: inset 0px 1px 0px #e6e8ec;
    left: 0%;
    width: 100%;
    width: 100%;
    background-color: white;
}

.complete-box .happybox-button{
    width: 90%;
    margin: 3% 0% 3% 5%;
}

.expanded-cart-header{
    position: sticky;
    top: 0%;
    background-color: white;
    padding: 2%;
    box-shadow: inset 0px -1px 0px #e6e8ec;
    border-radius: 16px 16px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.expanded-cart-header p{
    font-family: ff-more-web-pro-condensed,Karla,sans-serif;
    font-size: 6vw;
    line-height: 1.23;
    text-align: center;
    letter-spacing: 0.03em;
    color: #0F0C38;
}

.expanded-cart-header .input{
    font-size: 16px;
}

.box-name-legend{
    display: flex;
    align-items: center;
    padding-left: 3%;
}

    .product-summary .remove-all{
        text-align: right;
        font-size: 3.5vw;
    }

    .remove-all:hover{
        text-decoration: underline;
    }

    .item-summary{
        border-top: 1px solid #D1D5DB;
        padding: 3% 0%;
    }

    .item-title{
        font-weight: 700;
        font-size: 1.2rem;
        line-height: 1.5;
        color: #0f0c38;
    }

    .summary-container{
        padding: 0% 5%;
    }

    .subtotal-container,.taxes-container{
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #0F0C38;
        font-family: 'Karla';
        font-style: normal;
        font-weight: 700;
    }

    .subtotal-container p,.taxes-container p{
        margin: unset;
    }

    .subtotal-container{
        font-size: 4.2vw;
        line-height: 1.6;
        padding-bottom: 5%;
    }

    .taxes-container{
        font-size: 3.5vw;
        line-height: 150%;
        border-top: 1px solid #D1D5DB;
        padding-top: 3%;
    }

    .taxes-container strong{
        font-weight: 400;
    }

    .box-total{
        width: 100%;
        font-weight: 400;
        font-size: 3.5vw;
        line-height: 1.4;
        color: #0F0C38;
        margin-bottom: 3%;
    }

    .box-total p,.item-total p{
        margin: unset;
    }

    .total-container{
        display: flex;
        justify-content: space-between;
    }

    .individual-price{
        font-style: italic;
    }

    .item-total{
        display: flex;
        justify-content: space-between;
        width: 100%;
        font-weight: 700;
        font-size: 3.5vw;
        line-height: 150%;
        color: #0F0C38;
    }

    .total-container .service-fee{
        color: #5048E5;
    }

    .blue-legend{
        font-family: 'Karla';
        font-size: 3vw;
        line-height: 1.43;
        color: #5048E5;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .blue-legend img{
        width: 3%;
        margin-right: 2%;
    }

    .purple-legend{
        font-family: 'Karla';
        font-size: 3vw;
        line-height: 1.43;
        color: #66498c;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .notice-container{
    background: white;
    border: 1px solid #F5EEFE;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    padding: 4%;
    margin: 2% 0%;
    display: flex !important;
}

.notice-container .title{
    font-size: 3.5vw;
    font-weight: bold;
    line-height: 1.5;
}

.notice-container .subtitle{
    font-size: 3.5vw;
    line-height: 1.5;
}

.notice-container a{
    font-size: 3vw;
    text-decoration: underline;
    color: #a01adb;
    cursor: pointer;
}

.notice-container .main-image {
    width: 20%;
    padding: 1%;
    margin-right: 5%;
}

.slick-slider,.slick-list{
    width: 100%;
}

.slick-slide > div:first-child

.slick-prev:before, .slick-next:before{
    content: none !important;
}

.slick-arrow{
    width: 8vw;
    z-index: 1; 
}

.slick-prev{
    left: 0px;
} 
.slick-next{
    right: 0px;
}

.slick-arrow img{
    width: 100%;
}

    .multiship-block{
        background-color: #fdfddc;
        border: 1px solid gray;
        font-size: 3.5vw;
        border-radius: 8px;
        text-align: center;
        padding: .5rem .5rem;
        line-height: 1.2;
        width: 100%;
    }

    .multiship-block a{
        text-decoration: underline;
        color: #a01adb;
        cursor: pointer;
        font-size: inherit;
    }

    .alert-overlay{
        left: 12%;
        right: 12%;
        top: 20%;
        bottom: 0%;
        z-index: 1;
        background-color: rgba(255, 0, 0, 0.2);
        position: absolute;
    }

    .alert-icon{
        width: 20%;
        position: absolute;
        bottom: 5%;
        right: 15%;
        cursor: pointer;
        z-index: 1;
        animation: wobble 2s ease infinite;
    }

    @keyframes wobble {
    0% { transform: translateX(0%); }
    15% { transform: translateX(-25%) rotate(-5deg); }
    30% { transform: translateX(20%) rotate(3deg); }
    45% { transform: translateX(-15%) rotate(-3deg); }
    60% { transform: translateX(10%) rotate(2deg); }
    75% { transform: translateX(-5%) rotate(-1deg); }
    100% { transform: translateX(0%); }
    }

@media screen and (max-width: 767px){
        .cart-container{
            display: flex !important;
        }
    }
</style>